module.exports = __webpack_public_path__ + "fa-brands-400.1d5619cd804367cefe6d.svg";


//////////////////
// WEBPACK FOOTER
// F:/node/angular/complejidadesFrontend/~/@fortawesome/fontawesome-free/webfonts/fa-brands-400.svg
// module id = ../../../../@fortawesome/fontawesome-free/webfonts/fa-brands-400.svg
// module chunks = 2